import { render } from "./TestCompleteProcess.vue?vue&type=template&id=372b9425&scoped=true"
import script from "./TestCompleteProcess.vue?vue&type=script&lang=js"
export * from "./TestCompleteProcess.vue?vue&type=script&lang=js"

import "./TestCompleteProcess.vue?vue&type=style&index=0&id=372b9425&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-372b9425"]])

export default __exports__